import { render } from "./ReviewOfficialUse.vue?vue&type=template&id=9bf205d8&scoped=true"
import script from "./ReviewOfficialUse.vue?vue&type=script&lang=js"
export * from "./ReviewOfficialUse.vue?vue&type=script&lang=js"

import "./ReviewOfficialUse.vue?vue&type=style&index=0&id=9bf205d8&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bf205d8"]])

export default __exports__